import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import SelectListField from '../../../components/Fields/SelectListField';
import TextboxField from '../../../components/Fields/TextboxField';
import EmailField from '../../../components/Fields/EmailField';
import { ControlProps, FieldProps, LabelProps } from '../../../components/Fields/Types';
import useSelectListOptions from '../../../components/Hooks/SelectListOptionsHook/useSelectListOptions';
import UserEditModel from '../../../models/UserEditModel';
import BusinessPartnerControl from './BusinessPartnerControl';
import EmployeeControl from './EmployeeControl';
import CheckboxField from '../../../components/Fields/CheckboxField';

interface UserControlProps {
    formData: UserEditModel
    getLabelProps: (string) => LabelProps
    getControlProps: (string) => ControlProps
    getFieldProps: (string) => FieldProps
}

const UserControl: React.FC<UserControlProps> = ({ formData, getLabelProps, getControlProps, getFieldProps }) => {
    const languages = useSelectListOptions('api/v1/selectlist/Languages', '-- Select language');

    return <div>
        <Container fluid>
            <Row>
                <Col md='3'>
                    <img src={formData.fileUrl} style={{ width: '100%' }} />
                </Col>
                <Col md='5'>
                    <TextboxField {...getFieldProps('name')} />
                    <TextboxField {...getFieldProps('loginName')} />
                    <SelectListField {...getFieldProps('language')} options={languages} />
                    <EmailField {...getFieldProps('email')} />
                    <CheckboxField {...getFieldProps('isEnabled')} disabled />
                    <CheckboxField {...getFieldProps('isLocked')} disabled />
                </Col>
                <Col md='4'>
                    {formData.employee && <EmployeeControl getLabelProps={getLabelProps} getControlProps={getControlProps} getFieldProps={getFieldProps} disabled />}
                    {formData.businessPartnerUser && <BusinessPartnerControl getFieldProps={getFieldProps} />}
                </Col>
            </Row>
        </Container>
    </div>;
}
export default UserControl;